// nodejs8
import promiseFinally from 'promise.prototype.finally';
promiseFinally.shim();
